import { render } from "./FavoriteArtist.vue?vue&type=template&id=46fef241&scoped=true"
import script from "./FavoriteArtist.vue?vue&type=script&lang=js"
export * from "./FavoriteArtist.vue?vue&type=script&lang=js"

import "./FavoriteArtist.vue?vue&type=style&index=0&id=46fef241&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fef241"]])

export default __exports__